import { useState } from 'react';
import { Flex, Icon, Box, Button, Text, Spinner } from '@cad-arc';
import { sleep } from '@m43/core';
import { DEFAULT_MAP_VIEW_PREFERENCE_LOADING_DELAY } from './constants';

type SetDefaultMapViewPreferenceProps = {
    setDefaultMapView: () => void;
};

export const SetDefaultMapViewPreference = ({
    setDefaultMapView,
}: SetDefaultMapViewPreferenceProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);
        setIsConfirmed(false);

        try {
            await sleep(DEFAULT_MAP_VIEW_PREFERENCE_LOADING_DELAY);
            await Promise.resolve(setDefaultMapView());
            setIsConfirmed(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Flex alignItems="center" paddingTop="10px">
            <Button onClick={handleClick} disabled={isLoading}>
                Set
            </Button>
            <Box paddingLeft="10px">
                <Text variant="bodyMd">Make current map view default</Text>
            </Box>
            <Flex
                paddingLeft="10px"
                width="25px"
                height="25px"
                alignItems="center"
                justifyContent="center"
            >
                {isLoading && <Spinner size="sm" />}
                {!isLoading && isConfirmed && (
                    <Icon icon="Check" size="sm" color="positive.default" />
                )}
            </Flex>
        </Flex>
    );
};
